let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h94U4")).then(() => parcelRequire('d2HAI'));